import React, { Fragment, useState } from "react";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Typography from "@material-ui/core/Typography";

function RadioGroupQuestion(props) {

  function handleChange(e) {
        if (props.onChange){
            props.onChange(e.target.value);
        }
    
  }
  return (
      <Box pt={4}>
        <FormControl component="fieldset">
          <Typography  variant="h6" gutterBottom>
           {props.question}
          </Typography>
          <Box ml={2}>
          <RadioGroup
            aria-label="question"
            name="question"
            value={props.selected}
            onChange={handleChange}
          >

            {props.options.map((option,i)=>
            <FormControlLabel
            key={i}
            value={option.label}
            control={<Radio />}
            label={option.label}
          />
                )}
            
          </RadioGroup>
          </Box>
          
        </FormControl>
      </Box>
  );
}

export default RadioGroupQuestion;
